import {createSlice} from "@reduxjs/toolkit";

const alertStateInit = {
    showAlert:false,
    success:true,
    message:''
}

export const AlertSlice = createSlice({
    name:'AlertSlice',
    initialState:alertStateInit,
    reducers: {
        showAlert(state, action) {
            state.showAlert = true;
            state.success = action.payload.success;
            state.message = action.payload.message;
        },
        hideAlert(state) {
            state.showAlert = false;
        }
    }
});

// Uses this slice's own actions rather than the re-exports from storeIndex.
// Importing storeIndex from here created a cycle: storeIndex builds the store
// from AlertSlice.reducer, so whenever AlertSlice was evaluated first the
// reducer was still undefined and configureStore threw.
export const displayAlert = (success, message) => async (dispatch) => {
    dispatch(AlertSlice.actions.showAlert({
        success: success,
        message: message
    }));
}